const steps = [
  {
    step: "01",
    icon: "ri-qr-scan-line",
    title: "Scan QR Code",
    description:
      "Guest scans the QR code on their table using their smartphone camera. Instantly opens the digital menu — no app download needed.",
  },
  {
    step: "02",
    icon: "ri-survey-line",
    title: "Place Order",
    description:
      "Browse the full menu with images and descriptions. Customize items, add special requests, and submit the order directly from the phone.",
  },
  {
    step: "03",
    icon: "ri-tv-line",
    title: "Kitchen Display",
    description:
      "Order appears instantly on the KDS screen. Kitchen staff see all items clearly organized with prep times and priority indicators.",
  },
  {
    step: "04",
    icon: "ri-restaurant-2-line",
    title: "Serve & Enjoy",
    description:
      "Food is prepared and served to the table. Captain app tracks the entire journey, and guests can pay right from their phone.",
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14 md:mb-20">
          <span className="inline-block px-3 py-1 text-xs font-semibold text-accent-700 bg-accent-100 rounded-full mb-4">
            Simple Process
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            How It Works
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            From scanning to serving — a seamless flow that takes your
            restaurant operations to the next level.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 relative">
          {steps.map((step, idx) => (
            <div key={step.step} className="relative flex flex-col items-center text-center group">
              <div className="w-16 h-16 md:w-18 md:h-18 flex items-center justify-center rounded-full bg-accent-500 text-background-50 text-xl md:text-2xl font-heading font-bold mb-5 group-hover:scale-110 transition-transform duration-300 shadow-lg shadow-accent-500/25">
                {step.step}
              </div>

              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-lg bg-background-50 border border-background-200 text-primary-500 mb-4 group-hover:border-primary-300 transition-colors">
                <i className={`${step.icon} text-xl md:text-2xl`}></i>
              </div>

              <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 mb-2">
                {step.title}
              </h3>

              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed max-w-xs">
                {step.description}
              </p>

              {idx < steps.length - 1 && (
                <div className="hidden lg:block absolute top-12 -right-4 w-8 text-accent-400">
                  <i className="ri-arrow-right-line text-xl"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}